export const verifyEmailAddress = (email: string) => {
  const regex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/i

  return regex.exec(email)
}
